<template>
  <span class="scaling-svg-container">
    <svg
      id="Icon_cash"
      xmlns="http://www.w3.org/2000/svg"
      width="12"
      height="12"
      viewBox="0 0 12 12"
      class="scaling-svg"
    >
      <path
        id="Fill_1"
        data-name="Fill 1"
        d="M0,1.5A1.5,1.5,0,0,1,1.5,0h6A1.5,1.5,0,0,1,9,1.5V2A.5.5,0,0,1,8,2V1.5A.5.5,0,0,0,7.5,1h-6a.5.5,0,0,0-.5.5V7a.5.5,0,0,0,.5.5h6A.5.5,0,0,0,8,7V6.5a.5.5,0,0,1,1,0V7A1.5,1.5,0,0,1,7.5,8.5h-6A1.5,1.5,0,0,1,0,7Z"
        transform="translate(1 2)"
      />
      <path
        id="Fill_2"
        data-name="Fill 2"
        d="M3.25,2.5h-2a1.25,1.25,0,0,1,0-2.5h2a1.25,1.25,0,0,1,0,2.5ZM1.25,1a.25.25,0,1,0,0,.5h2a.25.25,0,1,0,0-.5Z"
        transform="translate(6.5 5)"
      />
    </svg>
  </span>
</template>

<script lang="ts">
import "reflect-metadata";
import { Component, Vue } from "vue-property-decorator";

@Component
export default class FinancesIcon extends Vue {}
</script>

<style>
</style>
